<template lang="pug">
AppPopover(
  ref="AppPopover"
  placement="right"
  extra-popover-classes="fc-event-container"
  boundaries-element="scrollParent"
  lazy
  @click="open"
)
  template(slot="body")
    .timesheet-event-popover-head
      .popover-head-left
        .project-cell-wrapper
          AppAvatarInitial.valign-top(:text="timeEntry.project.text")
          .time-entry-data.inline-block
            .project
              .inline-block
                .name.strong
                  | {{ timeEntry.project.text }}
            strong.hi-10.org-name.is-uppercase.text-lighter
              | {{ timeEntry.organization.text }}
            .task
              .inline-block
                .name.strong.small
                  | {{ taskName }}
      .popover-head-right
        .small.strong
          | {{ formattedRange }}
        .small.text-lighter
          | {{ timeEntry.start_time | formatDate }}
    table.table-condensed.table-borderless.table
      tbody
        tr
          td.strong.no-wrap Duration:
          td
            .inline-block
              data.duration
                |
                | {{ timeEntry.tracked | formatDuration }}
              |
              | hrs
            .manual-time.inline-block(v-if="timeEntry.work_break") Work break
            .manual-time.inline-block(v-else)
              | {{ numberToPercentage(timeEntry.manual) }}
              |
              | manual
            i.fa.fa-dollar.a-tooltip.ml-5(
              v-if="timeEntry.billable"
              v-tooltip="{ placement: 'right' }"
              title="Billable time"
            )
            TimeEntriesLockedPopover(
              v-if="showLocked(timeEntry)"
              trigger="hover"
              :reasons="timeEntry.allReasons"
            )
              .inline-block(slot="trigger")
                i.hi.hi-lock.ml-5
        tr(v-if="reasonsArePresent")
          td.strong.no-wrap {{ reasonString }}:
          td
            .text-overflow(
              v-for="reason in timeEntry.reasons"
              :key="reason.note"
            )
              | {{ reason.note | stripHTML }}
    .btn-group-spaced.is-justified(v-if="!showLocked(timeEntry)")
      a.btn.btn-sm.btn-danger.pull-left(
        v-tooltip="{ placement: 'bottom', html: true }"
        data-container="body"
        :title="deleteTimeEntryTooltip"
        :disabled="preventOwnTimeDeletion || timeEntry.manual_time_request"
        @click="openDialog('delete')"
      ) Delete
      a.btn.btn-sm.btn-primary.pull-right(
        v-tooltip="{ placement: 'bottom', html: true }"
        data-container="body"
        :disabled="editDisabled"
        :data-original-title="timeEntry.modifiableTooltip"
        @click="openDialog('edit')"
      ) Edit
      a.btn.btn-sm.btn-default.pull-right(
        v-if="!timeEntry.work_break"
        v-tooltip="{ placement: 'bottom', html: true }"
        data-container="body"
        :disabled="editDisabled"
        :data-original-title="timeEntry.modifiableTooltip"
        @click="openDialog('split')"
      ) Split
  template(slot="trigger")
    slot(name="trigger")
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { isEmpty } from 'lodash-es';
import { formatDatetimeRange } from '~/utils/time_utils';
// TODO (unlocking time): Use the popover for the cases where time can't get changed.
import TimeEntriesLockedPopover from '../TimeEntriesLockedPopover.vue';

export default {
  name: 'TimeEntriesCalendarEventPopover',
  components: {
    TimeEntriesLockedPopover,
  },
  props: {
    timeEntry: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['showLocked']),
    ...mapState({
      preventOwnTimeDeletion: 'prevent_own_time_deletion',
    }),
    reasonsArePresent() {
      return !isEmpty(this.timeEntry.reasons);
    },
    hasMultipleReasons() {
      return this.timeEntry.reasons.length > 1;
    },
    reasonString() {
      return this.hasMultipleReasons ? 'Reasons' : 'Reason';
    },
    formattedRange() {
      return formatDatetimeRange(this.timeEntry.start_time, this.timeEntry.stop_time, { style: 'time' });
    },
    taskName() {
      const task = this.timeEntry.task;

      return task ? task.text : '';
    },
    editDisabled() {
      return this.timeEntry.editDisabled;
    },
    deleteTimeEntryTooltip() {
      return this.preventOwnTimeDeletion ? 'You do not have permission to delete time' : null;
    },
  },
  methods: {
    numberToPercentage(num) {
      return ((num / this.timeEntry.tracked) * 100).toFixed(0) + '%';
    },
    openDialog(type) {
      const openEdit = (type === 'edit' || type === 'split') && !this.editDisabled;
      const openDelete = type === 'delete' && !this.preventOwnTimeDeletion && !this.timeEntry.manual_time_request;

      if (openEdit || openDelete) {
        this.$refs.AppPopover.close();
        this.$emit('open-dialog', { type, timeEntryId: this.timeEntry.id });
      }
    },
    open() {
      this.$refs.AppPopover.close();
    },
  },
};
</script>
